<!--
=========================================================
* Vue Material Dashboard 2 - v3.1.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-material-dashboard-2
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<template>
  <sidenav
    :custom_class="color"
    :class="[isRTL ? 'fixed-end' : 'fixed-start']"
    v-if="showSidenav"
  />
  <main
    class="main-content position-relative max-height-vh-100 h-100 overflow-x-hidden"
  >
    <navbar
      :class="[isNavFixed ? navbarFixed : '', isAbsolute ? absolute : '']"
      :color="isAbsolute ? 'text-white opacity-8' : ''"
      :minNav="navbarMinimize"
      v-if="showNavbar"
    />
    <router-view />
    <app-footer v-show="showFooter" />
  </main>
</template>

<script>
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import { mapMutations, mapState } from "vuex";

export default {
  name: "App",
  components: {
    Sidenav,
    Configurator,
    Navbar,
    AppFooter,
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
  },
  computed: {
    ...mapState([
      "isRTL",
      "color",
      "isAbsolute",
      "isNavFixed",
      "navbarFixed",
      "absolute",
      "showSidenav",
      "showNavbar",
      "showFooter",
      "showConfig",
      "hideConfigButton",
    ]),
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";

    const sidenav = document.getElementsByClassName("g-sidenav-show")[0];

    if (window.innerWidth > 1200) {
      sidenav.classList.add("g-sidenav-pinned");
    }
  },
};
</script>

<style>
/* GLOBAL OVERRIDE - KILL ALL GREEN BORDERS */
.form-control {
  border-color: #b03a45 !important;
}

.form-control:focus {
  border-color: #b03a45 !important;
  border: 1px solid #b03a45 !important;
  box-shadow: 0 0 0 0.1rem rgba(176, 58, 69, 0.25) !important;
  outline: 0 !important;
}

.input-group .form-control {
  border-color: #b03a45 !important;
}

.input-group.focused .form-control {
  border-color: #b03a45 !important;
}

.input-group.is-focused .form-control {
  border-color: #b03a45 !important;
}

/* Override any possible green states */
.form-control.is-valid {
  border-color: #b03a45 !important;
}

.form-control:valid {
  border-color: #b03a45 !important;
}

/* NUCLEAR OPTION - Override everything */
* {
  border-color: #b03a45 !important;
}

.form-control:focus:not(.is-invalid) {
  border-color: #b03a45 !important;
}
</style>
